<IziGrid class="left-panel-intro" height="100%" width="100%">
  <IziCol xl="2" />
  <IziCol xl="8" class="intro-game">
    <IziGrid>
      <IziCol class="col-title-intro">
        Let's iZi your mind, by:
      </IziCol>
      <IziCol class="note">- Joining diverse and unique challenges</IziCol>
      <IziCol class="note">- Competing with friends</IziCol>
      <IziCol class="note">- Learning while having fun</IziCol>


      <IziCol xl="12">
        <IziGrid>
          <IziCol xl="12" class="col-card-intro">
            <IziCard>
              <IziGrid>
                <IziCol class="card-intro-title">
                  “izi” your mind with the featured Challenge of the month. Try it out!
                </IziCol>
                <IziCol class="col-video-intro">
                  <iframe class="video-intro" src="https://www.youtube.com/embed/WQmGwmc-XUY?controls=0"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </IziCol>
                <IziCol class="game-title">
                  <span>Among US</span>
                </IziCol>
                <IziCol class="game-subtitle">
                  <span>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                    labore et dolore magna aliqua.</span>
                </IziCol>
                <IziCol class="col-action-intro">
                  <IziButton label="Compete Now" buttonType="primary" theme="outlined" />
                </IziCol>
              </IziGrid>
            </IziCard>
          </IziCol>
        </IziGrid>
      </IziCol>
    </IziGrid>
  </IziCol>
  <IziCol xl="2" />
</IziGrid>